import React from 'react'
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import gallaryImgThree from '../assets/makoko/makoko2.jpeg';

function ProjectView() {
    const projects = [
        {
            id: 'makoko-2024',
            name: 'Makoko Outreach',
            image: gallaryImgThree,
            year: 2024
        },
    ]

    return (
        <>
            <main className='bg-[#FFFAE5]'>
                <Navbar inverse={true} />

                <section className='w-full md:w-11/12 mx-auto flex flex-col gap-y-4 mt-16'>
                    <div className='w-2/12 h-1 bg-black mx-3 xl:mx-0'></div>

                    <div className='w-full lg:w-9/12 mb-16 px-3 xl:px-0'>
                        <h2 className='text-6xl font-bold uppercase tf-rozha tracking-wide'>PROJECTS</h2>
                        <p className='text-2xl tf-inter tracking-widest leading-loose font-extralight'>Explore our recent projects showcasing little and impactful solutions to the community.</p>
                    </div>
                </section>


                <section className='grid grid-cols-1 sm:grid-cols-2 gap-y-4 p-0.5 py-4'>
                    {
                        projects.map(project => {
                            return <Link to={`/projects/${project.id}`} key={project.id}> 
                                <div className='flex flex-col gap-y-1 cursor-pointer' >
                                    <div className='w-full min-h-[420px] sm:min-h-[590px] bg-center bg-no-repeat bg-cover' style={{ backgroundImage: `url(${project.image})` }}></div>
                                    <div className='flex mx-3 gap-x-3 place-items-center justify-between'>
                                        <h2 className='tf-inter text-4xl font-semibold text-md'>{project.name}</h2>
                                        <h3 className='tf-bellefair text-2xl font-thin'>({project.year})</h3>
                                    </div>
                                </div>
                            </Link>
                        })
                    }
                </section>
            </main>

            <Footer />
        </>
    )
}

export default ProjectView